import { Fonts } from '@styles/index';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';

const getTypographyVariant = (variant: UN_ICONS_TYPOGRAPHY_VARIANT) => {
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.H1) {
    return {
      desktopSize: '48px',
      mobileSize: Fonts.H3,
      desktopWeight: Fonts.BOLD,
      mobileWeight: Fonts.BOLD
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.H2) {
    return {
      desktopSize: Fonts.H2,
      mobileSize: Fonts.H5,
      desktopWeight: Fonts.BOLD,
      mobileWeight: Fonts.SEMIBOLD
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.H3) {
    return {
      desktopSize: Fonts.H4,
      mobileSize: Fonts.H5,
      desktopWeight: Fonts.BOLD,
      mobileWeight: Fonts.SEMIBOLD
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.H6) {
    return {
      desktopSize: Fonts.H7,
      mobileSize: Fonts.H7,
      desktopWeight: Fonts.REGULAR,
      mobileWeight: Fonts.REGULAR
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.SUBTITLE1) {
    return {
      desktopSize: Fonts.H4,
      mobileSize: Fonts.H6,
      desktopWeight: Fonts.SEMIBOLD,
      mobileWeight: Fonts.REGULAR
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.SUBTITLE2) {
    return {
      desktopSize: Fonts.H5,
      mobileSize: Fonts.H6,
      desktopWeight: Fonts.REGULAR,
      mobileWeight: Fonts.REGULAR
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.BODY1) {
    return {
      desktopSize: Fonts.H6,
      mobileSize: Fonts.H6,
      desktopWeight: Fonts.REGULAR,
      mobileWeight: Fonts.REGULAR
    };
  }
  if (variant === UN_ICONS_TYPOGRAPHY_VARIANT.BODY2) {
    return {
      desktopSize: Fonts.H6,
      mobileSize: Fonts.H7,
      desktopWeight: Fonts.REGULAR,
      mobileWeight: Fonts.REGULAR
    };
  }
  return {
    desktopSize: Fonts.H6,
    mobileSize: Fonts.H7,
    desktopWeight: Fonts.REGULAR,
    mobileWeight: Fonts.REGULAR
  };
};

export default getTypographyVariant;
